<div *ngIf="imageIsLoaded" class="rounded-circle" [ngClass]="imageClass">
  <img alt="" class="rounded-circle custom-image" [src]="image" [height]="size" [width]="size"/>
</div>

<div class="avatar ms-0 blue-background" [ngClass]="defaultImageClass" *ngIf="!imageIsLoaded">
  <img class="default-image" alt="" [src]="defaultImage"/>
</div>
